var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYouTubeRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.509.317c-6.157-.424-19.87-.422-26.018 0C.834.775.05 4.83 0 15.5c.05 10.652.827 14.723 7.491 15.183 6.15.422 19.861.424 26.018 0C40.166 30.225 40.95 26.17 41 15.5 40.95 4.848 40.173.777 33.509.317z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.509.317c-6.157-.424-19.87-.422-26.018 0C.834.775.05 4.83 0 15.5c.05 10.652.827 14.723 7.491 15.183 6.15.422 19.861.424 26.018 0C40.166 30.225 40.95 26.17 41 15.5 40.95 4.848 40.173.777 33.509.317zM15.375 22.39V8.61l13.667 6.877-13.667 6.9z",
    fill: "red"
  })));
}

export default SvgYouTubeRed;